import styled from 'styled-components'

const AlertSnackBarContainer = styled.div`
  position: fixed;
  z-index: 3400;
  left: 50%;
  right: auto;
  bottom: 24px;
  transform: translateX(-50%);
  min-width: 288px;
  border-radius: 2px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.colors.surface.foreground};
  color: ${({ theme }) => theme.colors.text.text700};
  box-shadow: 0 0 8px 0 ${({ theme }) => theme.colors.text.textMuted16};
  transition: all 0.2s;

  @media screen and (max-width: 600px) {
    left: 8px;
    right: 8px;
    bottom: 8px;
    transform: none;
    min-width: unset;
  }
`
const AlertSnackBarText = styled.p`
  font-size: 0.875rem;
  user-select: none;
  ::first-letter {
    text-transform: uppercase;
  }
`
const AlertSnackBarCloseBtn = styled.button`
  all: unset;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  user-select: none;
`

export { AlertSnackBarContainer, AlertSnackBarText, AlertSnackBarCloseBtn }
